import { Box, ClickAwayListener, Divider, IconButton, Stack, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React, { useContext, useMemo, useState } from "react";
import { scrollbarStyle } from '../../../shared/dashboard';
// import DashboardTimeline from "../../organisms/dashboard-timeline/DashboardTimeline";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import classNames from "classnames";
import { DashboardContext } from "../../../contexts/DashboardContext";
import { Dashboard, EmailBody } from "../../../types/files";
import ContentActivityFeed from "../../molecules/home-companies/ContentActivityFeed";
import DashboardQueries from "../dashboard-queries/DashboardQueries";
import DashboardMetricsTimelineV2 from "../dashboard-timeline/DashboardMetricsTimelineV2";

const useStyles = makeStyles((theme) => ({
    panel: {
        height: '100%',
        width: '100%',
        minWidth: 'calc(100vw - 94px - 550px)',
        maxWidth: 'calc(100vw - 94px - 135px)',
        padding: 8,
        transition: 'width .3s ease',
        overflowX: 'hidden',
        overflowY: 'auto',
        ...scrollbarStyle,
    },
    expanded: {
        height: '100%',
        width: '100%',
        minWidth: 'calc(100vw - 94px - 156px)',
        maxWidth: '100%',
    },
    title: {
        fontFamily: 'Inter',
        fontSize: '1.3rem !important',
        fontWeight: 'bold',
        color: theme.colors.neutral['700'],
    },
    activity: {
        overflowX: 'hidden',
        overflowY: 'auto',
        zIndex: 1300,
        ...scrollbarStyle,
    },
    feed: {
        width: '100%',
        height: '100%',
        overflowY: 'auto',
        overflowX: 'hidden',
        ...scrollbarStyle,
    },
}));

const DashboardOverview: React.FC<{}> = () => {
    const classes = useStyles();
    const { dashboard, isPublicView } = useContext(DashboardContext);
    const [expanded, setExpanded] = useState<boolean>(false);

    const boxShadow = '-8px 8px 12px rgba(0, 0, 0, 0.15), -16px 16px 14px rgba(0, 0, 0, 0.1), -24px 24px 16px rgba(0, 0, 0, 0.075), -32px 32px 24px rgba(0, 0, 0, 0.05)';
    const height = 'calc(100vh - 140px)';

    const sortedActivities = useMemo(() => {
        const activityItems: { dashboard: Dashboard, emailBody?: EmailBody, createdAt: string, type: 'attached' | 'created' }[] = [];

        if (!!dashboard) {
            activityItems.push({ dashboard, createdAt: String(dashboard.createdAt), type: 'created', });
            dashboard?.emailBodies?.forEach(emailBody => activityItems.push({
                dashboard, emailBody, createdAt: String(emailBody.createdAt), type: 'attached',
            }));
        }

        return activityItems.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
    }, [dashboard]);

    if (!dashboard)
        return (<></>);

    return (<>
        <Stack direction="row" alignItems="flex-start" width="100%" height="100%">
            <Stack direction="column" className={classes.panel} alignItems="stretch" justifyContent="flex-start"
                sx={isPublicView ? { maxWidth: 'unset !important'} : {}}>
                <Box className={classNames(expanded && classes.expanded)}>
                    <Box padding="12px 0" />
                    <DashboardQueries />
                    <Divider sx={{ mb: "16px !important"}}/>
                    <DashboardMetricsTimelineV2 />
                    {/* <DashboardTimeline /> */}
                </Box>
            </Stack>
            {expanded ? (<>
                <ClickAwayListener onClickAway={(e) => { e.stopPropagation(); setExpanded(false); }}>
                    <Stack className={classes.activity} width="100%" height={height} p={1}
                        sx={{ boxShadow }}>
                        <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between" mb={1}>
                            <Typography className={classes.title} ml={1}>
                                {`Your ${dashboard.title} feed`}
                            </Typography>
                            <Box mr="16px !important">
                                <IconButton onClick={(e) => {
                                    e.stopPropagation();
                                    setExpanded(false);
                                }}> <ArrowForwardIosIcon /> </IconButton>
                            </Box>
                        </Stack>
                        <Divider sx={{ width: '100%' }} />
                        <Stack direction="column" className={classes.feed} alignItems="stretch" mt={2}>
                            {sortedActivities.map((activity, i) => (
                                <ContentActivityFeed activity={activity} vertical
                                    key={`activity-feed-116-${i}-` + activity.dashboard.id}/>
                            ))}
                        </Stack>
                    </Stack>
                </ClickAwayListener>
            </>) : !isPublicView && (<>
                <Divider orientation="vertical" sx={{ height, marginTop: '-8x !important' }} />
                <Stack direction="column" className={classes.activity} spacing={3} alignItems="center" mt={1} px={3}
                    sx={{ width: 'fit-content', height: '100%', cursor: 'pointer'}}
                    onClick={(e) => {
                        e.stopPropagation();
                        setExpanded(true);
                    }}>
                    <IconButton onClick={(e) => {
                        e.stopPropagation();
                        setExpanded(true);
                    }}> <ArrowBackIosIcon /> </IconButton>
                    <FormatAlignRightIcon sx={{ fill: 'rgba(0, 0, 0, 0.5)' }} />
                </Stack>
            </>)}
        </Stack>
    </>);
}

export default DashboardOverview;